import SEO from '../components/SEO';

export default function OurStory() {
  return (
    <section className="fixed top-0 left-0 w-full h-dvh bg-gradient-to-br from-[#f1ede7] via-[#ece6de]
    to-[#e4ded4] text-[#161616] pt-20 sm2:pt-22 md:pt-30 lg:pt-[150px] overflow-y-auto ">
      <SEO
        title="Our Story - Meet the Artist Behind Let's Face It Studio"
        description="Learn the story behind Let's Face It Studio — a luxury makeup brand rooted in inclusivity, authenticity, and the belief that beauty is a spectrum. Based in Atlanta, GA."
        keywords="makeup artist story, Atlanta makeup artist, inclusive beauty, luxury makeup studio, about us"
        canonical="https://letsfaceitcosmetics.com/our_story"
      />

      <style>{`
        .mobile-watermark { 
          position: fixed !important;
          inset: 0;
          display: block; 
        }
        .desktop-image    { display: none; }

        @media (min-width: 1500px) {
          .mobile-watermark { display: none; }
          .desktop-image    { display: block; }

          .story-container {
            margin-left: 80px;
            margin-right: 80px;
          }
          .story-content {
            max-width: 59%;
          }
        }

        @media (min-width: 1024px) and (max-width: 1550px) {
          .story-container {
            margin-left: 60px;
            margin-right: 60px;
          }
        }
      `}</style>

      <div className="relative min-h-[calc(100vh-150px)] w-full flex flex-col justify-center">

        {/* Mobile watermark → NOW FIXED, ZERO SCROLL */}
        <div className="mobile-watermark pointer-events-none opacity-[13%] -translate-y-3
        xs:translate-y-1 sm:translate-y-25 sm2:translate-y-28 md:translate-y-18">
          <img
            src="/images/laura.png"
            alt="Laura - Lead Makeup Artist"
            className="absolute bottom-0 right-0 h-full w-full object-cover object-center"
          />
        </div>

        {/* Desktop fixed Laura */}
        <div className="desktop-image fixed top-[150px] right-0 pointer-events-none z-0">
          <img
            src="/images/laura.png"
            alt="Laura - Lead Makeup Artist"
            className="h-[calc(100vh-150px)] w-auto object-contain object-top"
          />
        </div>

        <div className="relative z-10">
          <div className="w-full">
            <div className="story-container px-6 sm:px-14  lg:px-0">
              <div className="story-content space-y-5 md:space-y-3 py-10 md:py-8 md:pr-7">

                <div className="header-section space-y-3 xsm2:mt-4 sm:mt-7  lg:mt-0">
                  <span className="text-sm uppercase tracking-[0.35em] text-[#5b5141]">
                    Our Story
                  </span>
                  <h1 className="font-mak text-5xl md:text-6xl leading-[0.95] text-[#1b1b1b] mt-4 sm:mt-[20px]">
                    Luxury artistry for every moment.
                  </h1>
                </div>

                <div className="paragraph-content space-y-5 lg:space-y-3 pt-0 md:pl-0 leading-[1.8] lg:pl-8">
                  <p className="text-base sm:text-[21px]  text-[#3c3c3c]">
                    My grandmother did not have access to luxury or beauty products, but she sustained her community with
                    grace, wisdom, and dignity. She saw beauty not in packaging, but in people. My mother was never considered
                    beautiful by society's standards, yet she lives with a fierce determination and unshakable strength. I stand
                    as a testament that there is beauty in resilience—that power, softness, and authenticity can live in the same face.
                  </p>

                  <p className="text-base sm:text-[21px] leading-[1.8] text-[#3c3c3c]  md:pt-1">
                    As a makeup artist and creative, I believe beauty should never be gatekept. My artistry is grounded
                    in inclusivity and driven by integrity—everyone deserves to feel seen, valued and celebrated. I approach
                    every client with care and respect, knowing that makeup is not just about transformation, but about affirmation.
                    My mission is to create a space where every skin tone, gender expression, age, and story is honored.
                  </p>

                  <p className="text-base sm:text-[21px] leading-[1.8] text-[#3c3c3c] md:pt-1">
                    This brand is not just about products or services—it's about people. It's a platform where
                    beauty meets authenticity, and where every face is welcome. Whether you're preparing for your moment
                    or just rediscovering your power, I am here to walk alongside you with tools, knowledge, and care.
                  </p>

                  <p className="text-base sm:text-[21px] leading-relaxed text-[#3c3c3c] font-medium md:pt-1">
                    Beauty is not a standard—it is a spectrum. And I'm here for all of it!
                  </p>
                </div>

                <div className="pt-10  md:pt-16  md:pb-3 lg:pb-0 lg:pt-25 -mt-12 sm2:-mt-18 md:-mt-25 md:-mr-6  lg:-mr-10 lg:-mt-[147px] flex justify-end">
                  <img
                    src="/images/Sig.png"
                    alt="Signature"
                    className="h-auto w-90 md:w-64 lg:w-72 xl:w-100 "
                        style={{ filter: "brightness(0) invert(0)" }}

                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
